export const categories = [
  {
    slug: 'access-guide',
    name: '访问指引',
    description: '提供91n.con最新访问方法、入口地址及网络优化指南',
    icon: 'ri-compass-3-line',
    count: 12,
    color: 'primary',
  },
  {
    slug: 'announcements',
    name: '最新公告',
    description: '官方动态、系统升级、服务变更等重要通知',
    icon: 'ri-megaphone-line',
    count: 8,
    color: 'accent',
  },
  {
    slug: 'tutorials',
    name: '使用教程',
    description: '新手指南、功能详解、操作技巧等实用教程合集',
    icon: 'ri-book-open-line',
    count: 15,
    color: 'secondary',
  },
  {
    slug: 'security',
    name: '安全须知',
    description: '账号安全、隐私保护、防诈骗等安全相关重要知识',
    icon: 'ri-shield-keyhole-line',
    count: 6,
    color: 'primary',
  },
  {
    slug: 'faq-collection',
    name: '常见问题',
    description: '汇总用户最常遇到的问题及详细解答',
    icon: 'ri-question-line',
    count: 20,
    color: 'accent',
  },
];